document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-copy-code]');

  if (!button) return;

  const code = button.getAttribute('data-copy-code');
  const label = button.querySelector('[data-copy-label]');

  navigator.clipboard.writeText(code).then(function () {
    button.classList.add('is-copied');

    if (label) {
      label.textContent = 'Copied!';
    }

    setTimeout(function () {
      button.classList.remove('is-copied');

      if (label) {
        label.textContent = 'Copy';
      }
    }, 1800);
  });
});